// extracted by mini-css-extract-plugin
export default {"header":"SolvencyFormHeader_header__JdYhL"};